// Bottom tab bar, rendered once by LeagueLayout instead of imported per-page.
// Post-draft: League / Lineup / Scoreboard / Teams. Pre-draft: Draft /
// Scouting / League. isDraftComplete (LeagueContext) picks the set.
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useLeague } from '../../context/LeagueContext';
import { Trophy, User, Activity, Users, Zap, Search } from 'lucide-react';

function TabBar() {
  const { leagueId } = useParams();
  const { isDraftComplete, loading } = useLeague();
  const location = useLocation();
  const navigate = useNavigate();

  if (loading) return null;

  const preDraftNav = [
    { key: 'draft-room', label: 'Draft',    icon: Zap,      path: `/${leagueId}/draft-room` },
    { key: 'scouting',   label: 'Scouting', icon: Search,   path: `/${leagueId}/scouting` },
    { key: 'league',     label: 'League',   icon: Trophy,   path: `/${leagueId}/league` },
  ];

  const postDraftNav = [
    { key: 'league',     label: 'League',     icon: Trophy,   path: `/${leagueId}/league` },
    { key: 'lineup',     label: 'Lineup',     icon: User,     path: `/${leagueId}/lineup` },
    { key: 'scoreboard', label: 'Scoreboard', icon: Activity, path: `/${leagueId}/scoreboard` },
    { key: 'teams',      label: 'Teams',      icon: Users,    path: `/${leagueId}/teams` },
  ];

  const navItems = isDraftComplete ? postDraftNav : preDraftNav;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 50,
      backgroundColor: 'var(--color-chrome)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderTop: '1px solid var(--color-chrome-border)',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      <div style={{
        maxWidth: 480, margin: '0 auto',
        display: 'flex',
        height: 49,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
        {navItems.map(({ key, label, icon: Icon, path }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={key}
              onClick={() => navigate(path)}
              style={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                gap: 2,
                border: 'none', background: 'none', cursor: 'pointer',
                minWidth: 44, minHeight: 44,
                WebkitTapHighlightColor: 'transparent',
                color: isActive ? 'var(--color-brand)' : 'var(--color-text-faint)',
              }}
            >
              <Icon size={25} strokeWidth={isActive ? 2.5 : 1.8} />
              <span style={{
                fontSize: 10,
                fontWeight: isActive ? 700 : 500,
                letterSpacing: 0.1,
              }}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TabBar;
